// extracted by mini-css-extract-plugin
module.exports = {"preview":"QueryPreview_preview__29omD","previewQueryName":"QueryPreview_previewQueryName__2uino"};